import authAxios from "../common/authAxios";

class EducationInfoService {

  async getEducationInstitutionTypes() {
    return await authAxios.get('/education/education-institutions-type');
  }

  //
  async getCountries() {
    return await authAxios.get('/location/country');
  }
  async getExamLanguages() {
    return await authAxios.get("/education/exam-language");
  }
  async getLocalityTypes() {
    return await authAxios.get('/location/locality-type');
  }

  // Фильтровать по Locality Type
  async getLocalities() {
    return await authAxios.get('/location/locality');
  }

  async getDistinctionMarkTypes() {
    return await authAxios.get('/education/distinction-mark-type');
  }

  async getAllKatoRegions() {
    return await authAxios.get('/kato/region')
  }

  async getAllKatoPlacesByRegion(regionCode) {
    return await authAxios.get(`/kato/region/places?region_code=${regionCode}`)
  }

  async getSchoolsByKatoId(katoId) {
    return await authAxios.get(`/schools/get-schools-by-kato-id?kato_id=${katoId}`)
  }

  async getEducationInfo() {
    // const response = '';
    // const { data } = response;

    // const educationalInfo = {
    //   country: data.country, // Объект
    //   kzGraduationLocality: data.kzGraduationLocality, // Объект
    //   kzEducationalInstitution: data.kzEducationalInstitution, // Объект
    //   educationalInstitution: data.educationalInstitution, // Строка
    //   distinctionMarkType: data.distinctionMarkType, // Объект
    //   kzGraduationCertificateSeries: data.kzGraduationCertificateSeries, // Строка
    //   kzGraduationCertificateNumber: data.kzGraduationCertificateNumber, // Строка
    //   kzGraduationCertificateAveragePoint: data.kzGraduationCertificateAveragePoint, // Строка
    //   graduationCertificateIssueDate: data.graduationCertificateIssueDate, // Дата
    //   graduationCertificateName: data.graduationCertificateName, // Строка
    //   nostrificationCertificateNumber: data.nostrificationCertificateNumber, // Строка
    //   nostrificationCertificateDate: data.nostrificationCertificateDate, // Дата
    //   graduationCertificate: data.graduationCertificate, // Объект
    //   graduationCertificateApplication: data.graduationCertificateApplication, // Объект
    //   specialityName: data.specialityName, // Строка
    //   educationInstitutionType: data.educationInstitutionType // Объект
    // };
 
    return await authAxios.get('/educational-info/');
  }

  async postEducationInfo(data) {
    return await authAxios.post('/educational-info/save-educational-info', data);
  }

}

export default EducationInfoService;